// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Suppliers_pageLayout__fRJcr"};